export * from '#root/ts/react/next/Link/Link.js';
export {default} from '#root/ts/react/next/Link/Link.js';
